import { getWindow } from "@faire/web--source/common/globals/getWindow";
export function markPageJsExecuted() {
    var _getWindow;
    var performance = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.performance;
    /**
     * performance.mark may be undefined in:
     *  - tests (js-dom)
     *  - server-side (next.js)
     *  - in old browsers
     **/ if (performance === null || performance === void 0 ? void 0 : performance.mark) {
        return performance.mark("page-js-executed");
    } else if (performance === null || performance === void 0 ? void 0 : performance.now) {
        return {
            startTime: performance.now()
        };
    } else {
        return undefined;
    }
}
